<wr-base-dialog status="primary"
                header="Gebäudeantrag genehmigen"
                [submitResponse]="submitAction"
                [disableSubmit]="!internalNumber().trim()"
                submitText="Genehmigen">

  <div class="dialog-content">
    <div class="error-message" *ngIf="!internalNumber().trim()">
      Die Eingabe einer internen Nummer ist erforderlich.
    </div>

    <div class="input-group">
      <label class="label" for="internalNumber">Objektnummer Intern</label>
      <input
        id="internalNumber"
        nbInput
        fullWidth
       

        placeholder="Interne Nummer eingeben..."
        [ngModel]="internalNumber()"
        (ngModelChange)="internalNumber.set($event)"
        [status]="!internalNumber().trim() ? 'danger' : 'basic'">
    </div>
  </div>

</wr-base-dialog>
